export default {
  cnCode: "KN-Code",
  factorValue: "Emissionsfaktor",
  unit: "Einheit",
  coefficient: "Prozesskoeffizient",
  description: "Beschreibung",
  createdAt: "Erstellt am",
  updatedAt: "Aktualisiert am",
  action: "Aktion",
  error: "Fehler",
  search: "Suchen",
  add: "Faktor hinzufügen",
  edit: "Bearbeiten",
  template: "Vorlage",
  csvTemplate: "CSV-Vorlage",
  xlsxTemplate: "XLSX-Vorlage",
  deleteConfirm: "Sind Sie sicher, dass Sie diesen Faktor löschen möchten?",
  deleteConfirmBatch: "Sind Sie sicher, dass Sie diese Faktoren löschen möchten?",
  import: "Faktoren importieren",
  export: "Faktoren exportieren",
  close: "Schließen",
  reset: "Erneut importieren",
  resetConfirm: "Sind Sie sicher, dass Sie erneut importieren möchten?",
  ok: "OK",
  clearInvalid: "Ungültige Daten löschen",
  showErrorRows: "Fehlerdaten anzeigen",
  hideErrorRows: "Fehlerdaten ausblenden",
  placeholder: {
    cnCode: "KN-Code eingeben (z.B. '24')",
    factorValue: "Emissionsfaktor eingeben",
    coefficient: "Prozesskoeffizient eingeben (0-1)",
    description: "Beschreibung eingeben (z.B. 'Verwendet für Low-Carbon-Stahlproduktion')",
    unit: "Einheit auswählen",
  },
  cnCodeRequired: "Bitte geben Sie den KN-Code ein",
  cnCodeMaxLength: "KN-Code darf 20 Zeichen nicht überschreiten",
  cnCodeFormat: "KN-Code darf nur Buchstaben, Zahlen und Unterstriche enthalten",
  cnCodeExample: "Beispiel: Stahl-KN-Code '24', Emissionsfaktor 1,5, Prozesskoeffizient 0,8",
  factorValueRequired: "Bitte geben Sie den Emissionsfaktor ein",
  factorValueMin: "Emissionsfaktor muss größer als 0 sein",
  factorValueUnit: "Einheit ist kg CO2e/kg, Zement in diese Einheit umrechnen",
  coefficientRequired: "Bitte geben Sie den Prozesskoeffizienten ein",
  coefficientRange: "Prozesskoeffizient muss zwischen 0 und 1 liegen",
  descriptionMaxLength: "Beschreibung darf 255 Zeichen nicht überschreiten",
  fetchError: "Faktoren konnten nicht abgerufen werden",
  addSuccess: "Faktor erfolgreich hinzugefügt",
  addError: "Faktor konnte nicht hinzugefügt werden",
  editSuccess: "Faktor erfolgreich aktualisiert",
  editError: "Faktor konnte nicht aktualisiert werden",
  deleteSuccess: "Faktor erfolgreich gelöscht",
  deleteError: "Faktor konnte nicht gelöscht werden",
  exportSuccess: "Export erfolgreich",
  exportError: "Faktoren konnten nicht exportiert werden",
  uploadFormatError: "Nur CSV- oder XLSX-Dateien werden unterstützt",
  headerInvalid: "Ungültiger Dateiheader, erwartet: cn_code,factor_value,coefficient,description",
  headerSkipped: "Header-Zeile übersprungen",
  importLimitExceeded: "Importdaten überschreiten das Limit (max. {max} gültige Zeilen)",
  noValidData: "Keine gültigen Faktordaten",
  parseError: "Datei konnte nicht analysiert werden",
  importError: "Faktoren konnten nicht importiert werden",
  importSuccess: "{count} Faktoren erfolgreich importiert",
  clearInvalidSuccess: "{count} ungültige Datenzeilen gelöscht",
  noInvalidData: "Keine ungültigen Daten zum Löschen",
  uploadText: "Klicken oder ziehen Sie die Datei in diesen Bereich, um sie hochzuladen",
  uploadHint: "Unterstützt CSV- und XLSX-Formate",
  unitRequired: "Bitte wählen Sie eine Einheit aus",
  unitInvalid: "Ungültige Einheit, nur kg CO2e/kg oder kg CO2e/Tonne unterstützt",
  batchDelete: "Massenlöschung",
  batchDeleteSuccess: "{count} Faktoren erfolgreich gelöscht",
  batchDeleteError: "Massenlöschung von Faktoren fehlgeschlagen",
};
